import { useEffect, useRef, useState } from "react";


const voteAnimStyle = document.getElementById("vote-anim-style") || (() => {
  const s = document.createElement("style");
  s.id = "vote-anim-style";
  s.textContent = `
    @keyframes vote-wave {
      0%   { transform: translateY(0) scale(1);    color: inherit; }
      25%  { transform: translateY(-4px) scale(1.2); color: var(--color-gold); }
      50%  { transform: translateY(0) scale(1.05);  color: var(--color-reward-warm); }
      100% { transform: translateY(0) scale(1);     color: inherit; }
    }
  `;
  document.head.appendChild(s);
  return s;
})();
void voteAnimStyle;

function AnimatedVoteCount({ value, large }: { value: number; large?: boolean }) {
  const prevRef = useRef(value);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (prevRef.current !== value) {
      prevRef.current = value;
      setAnimating(true);
      const timeout = setTimeout(() => setAnimating(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [value]);

  const chars = String(value).split("");

  return (
    <span
      className="inline-flex font-bold"
      style={{
        fontSize: large ? "18px" : undefined,
      }}
    >
      {chars.map((ch, i) => (
        <span
          key={`${value}-${i}`}
          className="inline-block"
          style={{
            animation: animating ? `vote-wave 0.5s ease-out ${i * 0.07}s both` : "none",
          }}
        >
          {ch}
        </span>
      ))}
    </span>
  );
}

export default AnimatedVoteCount;
